import { useParams } from 'react-router-dom';
// import UserForm from '../../components/UserForm';
import {
  createUserEndpoint,
  getUsersOfDeveloperEndpoint,
  assignUserToDeveloperEndpoint,
  updateUserPasswordEndpoint,
  userDeactivateEndpoint,
  userActivateEndpoint,
} from '../investors/services/developerUserService';
import { UserManagerServices } from '../../hooks/useUserManager';
import UserGenericForm from '../../components/UserGenericForm';

const InvestDeveloperUser = () => {
  const { id: developerId = '' } = useParams();

  const developerServices: UserManagerServices = {
    create: createUserEndpoint,
    list: (id, token) => getUsersOfDeveloperEndpoint(id || '', token),
    assign: (devId, userId, token) =>
      assignUserToDeveloperEndpoint(devId || '', userId, token),
    updatePassword: updateUserPasswordEndpoint,
    deactivate: userDeactivateEndpoint,
    activate: userActivateEndpoint,
  };

  return (
    <UserGenericForm
      contextId={developerId}
      services={developerServices}
      pageName="Administración de usuarios"
      pageParentName="Inversiones"
      getRolesPath={(userId) =>
        `/investors/configs/dev-management/${developerId}/users/${userId}/roles-management`
      }
      showOption={false}
    />
  );
};

export default InvestDeveloperUser;
